import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Calculates whether a color is light or dark and returns appropriate text color
 * @param hexColor - Color in hex format (e.g., "#FFFFFF")
 * @returns "text-white" for dark backgrounds, "text-gray-900" for light backgrounds
 */
export function getContrastTextColor(hexColor: string): string {
  // Remove # if present
  const hex = hexColor.replace('#', '');
  
  // Convert to RGB
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Calculate luminance using the formula: (0.299 * R + 0.587 * G + 0.114 * B)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Return white text for dark backgrounds (luminance < 0.5), black text for light backgrounds
  return luminance < 0.5 ? 'text-white' : 'text-gray-900';
}
